import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  constructor(
    private snackBar: MatSnackBar,
    private translateService: TranslateService
  ) {}

  openSnackBar(message: string, action: string, duration?: number) {
    this.snackBar.open(
      this.translateService.instant(message),
      this.translateService.instant(action),
      {
        duration: duration || 3000,
      }
    );
  }

  errorSnackBar(message: string, action: string, duration?: number) {
    this.snackBar.open(
      this.translateService.instant(message),
      this.translateService.instant(action),
      {
        duration: duration || 3000,
        panelClass: ['error-snackbar'],
      }
    );
  }

  warningSnackBar(message: string, action: string, duration?: number) {
    this.snackBar.open(
      this.translateService.instant(message),
      this.translateService.instant(action),
      {
        duration: duration || 5000,
        panelClass: ['warning-snackbar'],
      }
    );
  }
}
